<template>
  <header></header>
</template>

<script>
export default {
  name: 'GlobalHeader'
}
</script>
